import { Component } from 'solid-js'

const AgnaisticSettings: Component = () => {
  return (
    <>
      <div class="text-xl">Agnaistic Text To Speech</div>
    </>
  )
}

export default AgnaisticSettings
